import apiClient, { handleApiError } from '../lib/api-client';
import { API_ENDPOINTS } from '../config/api';

export interface UpdateProfileDto {
  username?: string;
  displayName?: string;
  bio?: string;
  dateOfBirth?: string;
  gender?: string;
  height?: number;
  shareData?: boolean;
}

export interface UserProfile {
  id: string;
  userId: string;
  username?: string;
  displayName?: string;
  avatarUrl?: string;
  bio?: string;
  dateOfBirth?: string;
  gender?: string;
  height?: number;
  shareData: boolean;
  createdAt: string;
  updatedAt: string;
}

export const userService = {
  async getProfile(): Promise<any> {
    try {
      // Backend returns: { id, email, createdAt, profile: {...}, healthData: [...] }
      const response = await apiClient.get<any>(API_ENDPOINTS.USERS.ME);
      // Handle both wrapped { data: ... } and direct response
      const userData = response.data?.data || response.data || response;
      return userData;
    } catch (error) {
      throw new Error(handleApiError(error));
    }
  },

  async updateProfile(data: UpdateProfileDto): Promise<any> {
    try {
      // Backend returns the updated profile object
      const response = await apiClient.put<any>(
        API_ENDPOINTS.USERS.UPDATE_PROFILE,
        data
      );
      // Handle both wrapped { data: ... } and direct response
      return response.data?.data || response.data || response;
    } catch (error) {
      throw new Error(handleApiError(error));
    }
  },

  async uploadAvatar(file: File): Promise<{ avatarUrl: string }> {
    try {
      const formData = new FormData();
      formData.append('avatar', file);
      const response = await apiClient.post<{ data: { avatarUrl: string } }>(
        API_ENDPOINTS.USERS.UPLOAD_AVATAR,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      return response.data.data || response.data;
    } catch (error) {
      throw new Error(handleApiError(error));
    }
  },
};

